export const formatSalary = (salary, jobType) => {
    if (!salary || salary.min === null || salary.min === undefined) return "Not Disclosed";
    if (salary.min === 0) return "Unpaid";
    
    const period = (jobType === "Full-Time" || jobType === "Permanent Employee") ? "per annum" : "per month";
    
    const formatAmount = (amount) => {
      amount = amount?.toString().replace(/,/g, '');
      if (amount >= 100000) {
        const lakhs = (amount / 100000).toFixed(1);
        return `${lakhs.endsWith('.0') ? lakhs.slice(0, -2) : lakhs} L`;
      } else if (amount >= 1000) {
        const thousands = (amount / 1000).toFixed(1);
        return `${thousands.endsWith('.0') ? thousands.slice(0, -2) : thousands}K`;
      }
      return Math.round(amount).toLocaleString('en-IN');
    };
    
    if (salary.max) {
      return `₹${formatAmount(salary.min)} - ₹${formatAmount(salary.max)} ${period}`;
    }
    return `₹${formatAmount(salary.min)} ${period}`;
  };